"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _vars = require("@devsta/ui-kit/dist/common/styles/vars");

var _Clip = _interopRequireDefault(require("../../Clip"));

require("../styles/_clips.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function Clips(_ref) {
  var heightPercent = _ref.heightPercent,
      clips = _ref.clips,
      connectDropTarget = _ref.connectDropTarget,
      isOver = _ref.isOver,
      placeholder = _ref.placeholder,
      handleClipResize = _ref.handleClipResize,
      onDeleteClip = _ref.onDeleteClip,
      onSnapClip = _ref.onSnapClip,
      onSnapMultipleClips = _ref.onSnapMultipleClips,
      canUpdateVideo = _ref.canUpdateVideo;
  return connectDropTarget( /*#__PURE__*/_react.default.createElement("div", {
    className: "timeline-clips",
    style: {
      height: "".concat(heightPercent, "%"),
      background: isOver ? _vars.COLOURS.grey.nevada : void 0
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "timeline-clips__inner"
  }, placeholder, clips.map(function (clip) {
    return (/*#__PURE__*/_react.default.createElement(_Clip.default, {
        key: clip.clipId,
        clip: clip,
        handleClipResize: handleClipResize,
        onDeleteClip: onDeleteClip,
        onSnapClip: onSnapClip,
        onSnapMultipleClips: onSnapMultipleClips,
        assetId: clip.assetId,
        canUpdateVideo: canUpdateVideo
      })
    );
  }))));
}

var _default = (0, _react.memo)(Clips);

exports.default = _default;